import React from 'react';
import FooterContent from './footer/FooterContent';
import CopyrightBar from './footer/CopyrightBar';

const Footer = () => {
  return (
    <footer className="w-full mt-auto">
      <FooterContent />
      <CopyrightBar />
    </footer>
  );
};

export default Footer;